export default __webpack_public_path__ + "static/media/phil_balance_bike_kids.654d28f7.jpeg";